import { Box, Button, Stack, Typography } from '@mui/material'
import { useCallback, useContext, useState } from 'react'
import { Breads } from 'src/components/atoms/BreadCrumbs'
import { CreateClientDialog, type FormState } from 'src/components/dialogs/client/CreateClientDialog'
import { AuthContext } from 'src/components/providers/AuthProvider'
import { ClientContext } from 'src/components/providers/ClientProvider'
import { useClients } from 'src/hooks/client/useClients'
import { ClientsTable } from 'src/pages/Clients/Table'
import { Invitations } from './Invitations'

export const Clients = () => {
  const [user] = useContext(AuthContext)
  const { client, selectClient, currentMember } = useContext(ClientContext)
  const { listClients, createGroupClient } = useClients(user!.uid)

  const [openCreate, setOpenCreate] = useState<boolean>(false)

  const handleSubmit = useCallback(
    async (value: FormState) => {
      if (!currentMember) {
        return
      }
      await createGroupClient(value, currentMember)
      await listClients.mutate()
      setOpenCreate(false)
    },
    [listClients.mutate, createGroupClient, currentMember],
  )

  return (
    <>
      <Breads breadIds={['clients']} />
      <Stack spacing={2}>
        <Typography variant="h5">グループ一覧</Typography>
        <Typography>所属するグループ一覧です</Typography>
        <ClientsTable currentClient={client} clients={listClients.data ?? []} selectClient={selectClient} />
      </Stack>
      <Box
        sx={{
          mt: 4,
        }}
      >
        <Button variant="contained" onClick={() => setOpenCreate(true)}>
          グループを作成する
        </Button>
      </Box>
      <Box
        sx={{
          mt: 4,
        }}
      >
        <Invitations user={user!} mutateClients={listClients.mutate} />
      </Box>
      <CreateClientDialog onClose={() => setOpenCreate(false)} open={openCreate} onSubmit={handleSubmit} />
    </>
  )
}
